import type { LanguageIsoCode, Program } from '@/graphql/graphql';
import Autoplay from 'embla-carousel-autoplay';
import { useLocale } from 'next-intl';
import type React from 'react';
import { useRef } from 'react';
import Mediacard from '../media-card';

interface UseControllerParams<T> {
    autoplay?: boolean;
    renderItem?: (item: T) => React.ReactNode;
    keyExtractor?: (item: T) => string | number;
}

export const useController = <T,>({ autoplay, renderItem, keyExtractor }: UseControllerParams<T>) => {
    const locale = useLocale().toLowerCase();
    const plugin = useRef(Autoplay({ delay: 2000, stopOnInteraction: false, stopOnMouseEnter: true }));

    const carouselPlugins = autoplay ? [plugin.current] : [];

    const getItemKey = (item: T, index: number): string | number =>
        keyExtractor ? keyExtractor(item) : ((item as Program).identifier?.id ?? index);

    const renderItemContent = (item: T): React.ReactNode =>
        renderItem ? renderItem(item) : <Mediacard program={item as Program} language={locale as LanguageIsoCode} />;

    return {
        carouselPlugins,
        getItemKey,
        renderItemContent,
    };
};
